export enum WordPressActions {
  LOADING_POSTS = "LOADING_POSTS",

  SET_POSTS = "SET_POSTS",
  RESET_POSTS = "RESET_POSTS",
}
